// Header
// Close MegaMenau when click outside of the menu
// Set Size of Overlay. Instead of having a default height of 48rem;

class Header {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        // CheckBox Trigger
        const menuTriggers = document.querySelectorAll('.js-menu-trigger');

        // Uncheck all checkBox Trigger to close all Submenue
        function uncheckAll() {
            for (let i = 0; i < menuTriggers.length; i += 1) {
                menuTriggers[i].checked = false;
            }
        }

        // Set BackgroundOverlay for Mega Dropdown
        function setSizeOfOverlay(element) {
            const subMenuTrigger = element.target.parentElement.getElementsByClassName('depth--0');
            const elementOverlay = element.target.nextSibling;
            const calculateHeight = ((subMenuTrigger[0].offsetTop + subMenuTrigger[0].offsetHeight) / 10);
            elementOverlay.style.height = `${calculateHeight}rem`;
        }

        // Listen for click clickedElements on body
        document.body.addEventListener('click', function (clickedElement) {
            if (clickedElement.target.checked) {
                for (let i = 0; i < menuTriggers.length; i += 1) {
                    if (menuTriggers[i].contains(clickedElement.target)) {
                        uncheckAll();
                        clickedElement.target.checked = true;
                        if (clickedElement.target.classList.contains('mega-menu-trigger')) {
                            setSizeOfOverlay(clickedElement);
                        }
                        break;
                    } else {
                        uncheckAll();
                    }
                }
            } else {
                uncheckAll();
            }
        });
    }
}

export default Header;
